import { Box, Text } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { SpaceMemberSelector } from 'apps/TenantApp/components/MemberSelector/SpaceMemberSelector';
import { InfoIcon } from 'components/icons';
import { OverlayProps, TaskOverlayBody } from 'components/TaskOverlay';
import { FirstStepTaskOverlay } from 'components/TaskOverlay/FirstStepTaskOverlay';
import React, { useState } from 'react';

interface AddOwnerModalProps extends OverlayProps {
  spaceId: string;
  currentOwnerIds: string[];
  onAddOwners(newOwnerIds: string[], onSuccess: () => void): void;
  isAddOwnersLoading: boolean;
}

export const AddOwnerModal: React.FC<AddOwnerModalProps> = ({
  spaceId,
  currentOwnerIds,
  onAddOwners,
  isOpen,
  onClose,
  isAddOwnersLoading,
  children,
}) => {
  const [selectedMemberIds, setSelectedMemberIds] = useState<string[]>([]);

  return (
    <FirstStepTaskOverlay
      title={t`Add owners`}
      submitButtonTitle={t`Done`}
      isOpen={isOpen}
      onClose={onClose}
      isDisabled={selectedMemberIds.length === 0}
      onCompleteTask={() => {
        onAddOwners(selectedMemberIds, () => {
          setSelectedMemberIds([]);
          onClose();
        });
      }}
      isLoading={isAddOwnersLoading}
    >
      <TaskOverlayBody>
        <SpaceMemberSelector
          spaceId={spaceId}
          selectedMemberIds={currentOwnerIds}
          disableEmailInvite
          selectedEmails={[]}
          onSelectedMembersUpdate={setSelectedMemberIds}
          onSelectedEmailsUpdate={() => {}}
        />
        {selectedMemberIds.length === 0 && (
          <Box color="gray.500">
            <Text fontWeight="bold">
              <InfoIcon /> {t`Select only people you trust.`}
            </Text>
            <Text>{t`Owners can:`}</Text>
            {children}
          </Box>
        )}
      </TaskOverlayBody>
    </FirstStepTaskOverlay>
  );
};
